import { create } from 'zustand';
import type { MapAction } from '@/types/askAi';

interface MapActionsState {
  pendingActions: MapAction[];
  pushActions: (actions: MapAction[]) => void;
  consume: () => MapAction[];
  clear: () => void;
}

export const useMapActionsStore = create<MapActionsState>((set, get) => ({
  pendingActions: [],
  pushActions: (actions) =>
    set((s) => ({ pendingActions: [...s.pendingActions, ...actions] })),
  consume: () => {
    const queued = get().pendingActions;
    if (queued.length === 0) return [];
    set({ pendingActions: [] });
    return queued;
  },
  clear: () => set({ pendingActions: [] }),
}));
